import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { FC, ReactNode } from 'react'
import { GRAY_700, GRAY_800, GRAY_900 } from 'constants/styling/theme'

import ButtonBase from '@mui/material/ButtonBase'
import Collapse from '@mui/material/Collapse'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

interface Props {
  title: string
  hint?: string
  count: number
  collapsible?: boolean
  isOpen?: boolean
  onToggle?: () => void
  children: ReactNode
}

export const OverviewSection: FC<Props> = ({ title, hint, count, collapsible = false, isOpen = true, onToggle, children }) => (
  <Stack component="section" gap="0.8rem">

    {collapsible &&
      <ButtonBase
        onClick={onToggle}
        aria-expanded={isOpen}
        sx={{ minHeight: '4.4rem', padding: '0 0.4rem', gap: '0.8rem', justifyContent: 'flex-start', borderRadius: '0.8rem' }}
      >

        <Stack flex={1} minWidth={0} gap="0.2rem" textAlign="left">

          <Typography variant="text-sm" fontWeight={600} color={GRAY_800} noWrap fontSize="1.3rem">
            {title}
          </Typography>

          {!!hint &&
            <Typography variant="text-xs" color={GRAY_700} noWrap>
              {hint}
            </Typography>
          }

        </Stack>

        <Typography variant="text-xs" color={GRAY_700}>
          {count}
        </Typography>

        {isOpen
          ? <ExpandLess sx={{ fontSize: '1.6rem', color: GRAY_700 }} />
          : <ExpandMore sx={{ fontSize: '1.6rem', color: GRAY_700 }} />
        }

      </ButtonBase>
    }

    {!collapsible &&
      <Stack direction="row" alignItems="baseline" gap="0.8rem" padding="0.4rem 0.4rem 0">

        <Stack flex={1} minWidth={0} gap="0.2rem">

          <Typography role="heading" aria-level={2} variant="text-sm" fontWeight={600} color={GRAY_900} noWrap fontSize="1.3rem">
            {title}
          </Typography>

          {!!hint &&
            <Typography variant="text-xs" color={GRAY_700} noWrap>
              {hint}
            </Typography>
          }

        </Stack>

        <Typography variant="text-xs" color={GRAY_700}>
          {count}
        </Typography>

      </Stack>
    }

    <Collapse in={isOpen} unmountOnExit>
      <Stack gap="0.8rem">
        {children}
      </Stack>
    </Collapse>

  </Stack>
)
